var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/_html.js